import { httpsCallable } from 'firebase/functions';

import { functions } from '@/src/lib/functions';

export type WritingAssistProfile = {
  writingAssist?: {
    autoCorrectEnabled?: boolean;
  } | null;
} | null | undefined;

export type WritingCorrectionSurface = 'comment' | 'post';

const correctWritingCallable = httpsCallable<
  {
    surface: WritingCorrectionSurface;
    text: string;
  },
  {
    changed: boolean;
    correctedText: string;
  }
>(functions, 'correctWriting');

function writingAssistEnabled(profile: WritingAssistProfile) {
  return profile?.writingAssist?.autoCorrectEnabled === true;
}

function shouldSkipCorrection(text: string) {
  return text.length < 3 || !/[A-Za-z]/.test(text);
}

export async function maybeCorrectWriting({
  profile,
  surface,
  text,
}: {
  profile: WritingAssistProfile;
  surface: WritingCorrectionSurface;
  text: string;
}) {
  const trimmedText = text.trim();

  if (!writingAssistEnabled(profile) || shouldSkipCorrection(trimmedText)) {
    return {
      changed: false,
      text: trimmedText,
    };
  }

  const result = await correctWritingCallable({
    surface,
    text: trimmedText,
  });
  const correctedText = result.data.correctedText.trim();

  return {
    changed: result.data.changed && correctedText !== trimmedText,
    text: correctedText || trimmedText,
  };
}
